import React from "react";

export default function FormField({ label, required, half, error, children }) {
    const className = ["pof-field", half ? "pof-field-half" : ""].filter(Boolean).join(" ");
    return (
        <div className={className}>
            <label className="pof-label">
                {label} {required && <span className="pof-required">*</span>}
            </label>
            {children}
            {error && <small className="pof-error">{error}</small>}
        </div>
    );
}
